import * as api from '@/api'

interface ChinaApk {
  url?: String
  version?: String
}

interface ChinaApkState {
  chinaApk?: ChinaApk
  isIosCn: boolean
  error?: Error
}

const state: ChinaApkState = {
  chinaApk: undefined,
  isIosCn: false,
  error: undefined
}

const getters = {
  chinaApk: (state : ChinaApkState): ChinaApk | undefined => state.chinaApk,
  isIosCn: (state : ChinaApkState): boolean => state.isIosCn
}

const mutations = {
  GET_CN_APK_SUCCESS(state: ChinaApkState, { chinaApk }: { chinaApk: ChinaApk; }) {
    state.chinaApk = chinaApk
    state.error = undefined
  },

  GET_CN_APK_SUCCESS_FAIL(state: ChinaApkState, error: Error) {
    state.error = error
  },

  SET_CN_IOS_SUCCESS(state: ChinaApkState, { isIosCn }: { isIosCn: boolean }) {
    state.isIosCn = isIosCn
  }
}

const actions = {
  async loadChinaApk({ commit, getters, dispatch }: any) {
    try {
      const chinaApk = await api.serve.getApkUrl()
      commit('GET_CN_APK_SUCCESS', { chinaApk })
    } catch (error) {
      commit('GET_CN_APK_SUCCESS_FAIL', error)
      throw error
    }
  },
  setIosCn({ commit, getters, dispatch }: any) {
    const isIosCn = true;
    commit('SET_CN_IOS_SUCCESS', { isIosCn });
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
